<!DOCTYPE html>
<div class="app-container">
  <wfdss-header [userIsElevated]="this.userHasElevatedRoles"></wfdss-header>
  <div class="router-outlet-container">
    <router-outlet></router-outlet>
  </div>
  <wfdss-footer></wfdss-footer>
</div>